















































































































import TimeClock from './comps/timeClock.vue'
import MyPrize from './comps/myPrize.vue'
import myPrizeMod from './comps/myPrizeMod.vue'
import showPrizeMod from './comps/showPrizeMod.vue'
import shareMod from './comps/shareMod.vue'
import rulesDiv from './comps/rulesDiv.vue'
import Swimlane from './comps/swimlane.vue'
import CourseBox from './comps/courseBox.vue'
import * as utils from '@ivy/fts/utils'
import axios from 'axios'
import conf from '../../config'

import LuckWheel from './drawPage/luckWheel.vue'
import LuckSquare from './drawPage/luckSquare.vue'
import MusicButton from './comps/music.vue'

import * as weixin from '@ivy/fts/weixin'
import showDiv, { closeAll } from '@ivy/fts/showDiv'
import { Component, Vue } from 'vue-property-decorator'
import * as envInfo from '@ivy/fts/envInfo/envInfo'
import { addStastics } from './util'

const env = envInfo.env

@Component({
  components: {
    TimeClock,
    MyPrize,
    Swimlane,
    CourseBox,
    rulesDiv,
    LuckWheel,
    LuckSquare,
    MusicButton,
  },
})
export default class LuckDrawPost extends Vue {
  loginInfo: any
  myPrizes: any = []
  prizeInfo: any = {}
  prizeIndex: number = 0
  currentPrize: any = {}
  records: any = []
  isOver: boolean = false
  lastNum: number = 0
  params: any = {}
  sharableNumber: number = 0
  messages: any = []
  messageList: any = []
  activeOver: boolean = false
  courseBoxId: number
  // floatWindowData: any
  showShareTime: number = 0
  showShareTimer: any = null
  isDeadline: boolean = false
  drawType: any = 'LuckWheel' // circle square
  account: any = {}
  ticket: number = 0
  welfare: any = {}
  isLotterying: boolean = false
  source
  courseList: any = []
  from: any
  showReturn: boolean = false
  get unReceiveCount() {
    let c = 0
    this.myPrizes.map(p => {
      if ((p.product_type === '常爸优惠券' && !p.used) || !p.is_receive) {
        c += 1
      }
    })
    return c
  }
  getChangeName(info) {
    if (info.chance_num_type === 'ticket') {
      return '兑换券'
    } else if (info.chance_num_type === 'integral') {
      return '青豆'
    } else if (info.chance_num_type === 'water') {
      return '金币'
    }
  }
  async isLogined() {
    let isLogin = await env.getIsLogin()
    if (!isLogin) {
      return env.login(null, this.afterLogin)
    }
  }
  async mounted() {
    await env.init(this.afterShare, this.afterLogin)
    // await store.login(this)
    let { activeId: active_id } = this.$route.query

    if (!active_id) {
      this.activeOver = true
      return this.$Toast(`活动未找到`)
    }
    addStastics({
      event_type: 'Display_Activity',
      activity_id: active_id,
      p1: null,
    })
    if (this.$route.query.from && this.isURL(this.$route.query.from)) {
      this.showReturn = true
      this.from = this.$route.query.from
    }
    this.params = {
      active_id,
      entrance: utils.isWeixin() ? `h5` : `app`,
    }
    await this.getPrizeInfo()
    if (this.prizeInfo.title.includes('购课抽大奖')) {
      this.courseBoxId = +active_id
    }
    this.drawType = { circle: 'LuckWheel', square: 'LuckSquare' }[
      `${this.prizeInfo.activity_type}` || 'circle'
    ]
    await this.getBigPrize()
    await this.couldShareTime()
    await this.countLastNum() // 获取剩余次数
    await this.getMyPrize()
    await this.getCourseBoxData() // 获取课程列表
    // await this.getFloatWindowData() // 获取悬浮窗数据
    if (
      ['ticket', 'integral', 'water'].includes(this.prizeInfo.chance_num_type)
    )
      await this.getAccount()
    env.type === 'wx' && (await this.setShare())
    env.type === 'ivydad' && (await this.setIvyShare())
  }
  async getAccount() {
    if (this.activeOver) return
    let getPublicParams = await this.getPublicParams()
    if (this.prizeInfo.chance_num_type === 'integral') {
      this.ticket = (await axios.get(
        `/api/mobile/activity/luckDrawTools/getMyAccountIntegral`,
        { params: getPublicParams }
      )).data
      return
    }
    if (this.prizeInfo.chance_num_type === 'water') {
      this.ticket = (await axios.get(
        `/api/mobile/activity/luckDrawTools/getMyAccountWater`,
        { params: getPublicParams }
      )).data
      return
    }
    let { data } = await axios.get(
      `/api/mobile/activity/luckDrawTools/getMyAccount`,
      {
        params: {
          ...getPublicParams,
        },
      }
    )
    this.account = data
    this.ticket = this.account.balance ? parseInt(this.account.balance, 0) : 0
  }
  goReturn() {
    window.location.href = this.from
  }
  async getBigPrize() {
    if (this.activeOver) return
    this.messageList = []
    const { data } = await axios.get(
      `/api/mobile/activity/luckyDraw/getBigPrize`,
      {
        params: this.params,
      }
    )
    this.messages = data
    this.messageList = this.messages.map(item => {
      return `${item.user_nick}：幸运的获得了${item.title}`
    })
  }

  async countLastNum() {
    if (this.activeOver) return
    let getPublicParams = await this.getPublicParams()
    let data
    try {
      data = (await axios.get(`/api/mobile/activity/luckyDraw/countLastNum`, {
        params: {
          ...this.params,
          ...getPublicParams,
        },
      })).data.count
    } catch (error) {
      if (
        (error.data && error.data.code === 'ACTIVITY_NOT_FOUND') ||
        error.code === 'ACTIVITY_NOT_FOUND'
      ) {
        this.activeOver = true
      }
    }
    this.lastNum = +data < 0 ? 0 : data
  }
  async getCourseBoxData() {
    let getPublicParams = await this.getPublicParams()
    if (this.courseBoxId) {
      this.source = env.type === 'ivydad' ? 'app' : ''
      const {
        data: { purchase_info },
      } = await axios.get(
        `/api/mobile/activity/luckDrawTools/getPurchaseOrderInfo`,
        {
          params: {
            ...getPublicParams,
            active_id: this.courseBoxId,
            source: this.source,
          },
        }
      )
      this.courseList = purchase_info
    }
  }
  async goShare() {
    let options = {
      title: this.prizeInfo.share_title,
      content: this.prizeInfo.share_detail,
      url:
        this.prizeInfo.share_url ||
        `${
          conf.env === 'production'
            ? 'https://m.ivydad.com'
            : 'http://m.ivydad.com.cn'
        }/h5/luckdraw?activeId=${this.$route.query.activeId}`,
      pic_url: this.prizeInfo.share_pic_url,
    }
    console.log('options', options)
    if (env.type === 'wx') showDiv(shareMod)
    await env.share(options, this.afterShare)
  }
  async afterShare() {
    if (!this.sharableNumber)
      return this.$Toast(`今日您已经没有抽奖机会了，明天可以继续抽奖哦。`)
    await axios.get(`/api/mobile/activity/luckyDraw/recordShare`, {
      params: {
        ...this.params,
        ...(await this.getPublicParams()),
      },
    })
    await this.couldShareTime()
    this.lastNum += 1
    this.$Toast('分享成功')
  }
  async countTime() {
    this.showShareTime = 0
    this.showShareTimer = setInterval(e => {
      this.showShareTime += 100
    }, 100)
  }
  async getMyPrize() {
    let { data } = await axios.get(
      `/api/mobile/activity/luckyDraw/getMyPrize`,
      {
        params: {
          ...this.params,
          ...(await this.getPublicParams()),
        },
      }
    )
    this.myPrizes = data
  }
  async getPrizeInfo() {
    let { data } = await axios.get(`/api/mobile/activity/luckyDraw/getDetail`, {
      params: {
        ...this.params,
        ...(await this.getPublicParams()),
      },
    })
    if (!data || !data.id) {
      this.activeOver = true
      return this.$Toast('抽奖活动结束啦')
    }
    this.prizeInfo = data
    this.isDeadline = !!(
      +new Date().getTime() >= +Date.newDate(data.award_deadline)
    )
    this.isOver = !!(+new Date().getTime() >= +Date.newDate(data.end_time))
  }
  async setShare() {
    await weixin.wxConfigReady()
    const link =
      !this.prizeInfo.share_url ||
      this.prizeInfo.share_url === 'null' ||
      this.prizeInfo.share_url === 'undefined'
        ? window.location.href
        : this.prizeInfo.share_url
    let options = {
      title: this.prizeInfo.share_title,
      desc: this.prizeInfo.share_detail,
      imgUrl: this.prizeInfo.share_pic_url,
      link,
    }
    console.log('options', options)
    weixin.weixinShareCallback(options, e => {
      if (e) {
        closeAll()
      }
    })
  }
  async setIvyShare() {
    await env.init()
    let options = {
      title: this.prizeInfo.share_title,
      content: this.prizeInfo.share_detail,
      url:
        this.prizeInfo.share_url ||
        `${
          conf.env === 'production'
            ? 'https://m.ivydad.com'
            : 'http://m.ivydad.com.cn'
        }/h5/luckdraw?activeId=${this.$route.query.activeId}`,
      pic_url: this.prizeInfo.share_pic_url,
    }
    await env.shareInfo(options)
  }
  async afterLogin() {
    await this.countLastNum() // 一旦登录后，重新查询剩余次数
    await this.getMyPrize() // 一旦登录后，重新查询我的奖品
    await this.getAccount() // 重新查询兑换券账户
    await this.getCourseBoxData() // 重新获取课程列表
  }
  async couldShareTime() {
    if (this.activeOver) return
    const { data } = await axios.get(
      `/api/mobile/activity/luckyDraw/couldShareTime`,
      {
        params: {
          ...this.params,
          ...(await this.getPublicParams()),
        },
      }
    )
    this.sharableNumber = +data.couldShareTime < 0 ? 0 : +data.couldShareTime
  }
  async showMyPrize() {
    await this.isLogined()
    if (this.isDeadline) return this.$Toast(`已经超过兑奖时间了哦~`)
    await showDiv(myPrizeMod, {
      backgroundColor: this.prizeInfo.primary_color,
      prizes: this.myPrizes,
      beginTime: this.prizeInfo.begin_time,
      endTime: this.prizeInfo.end_time,
    })
  }
  async getPrize(wheel) {
    await this.isLogined()
    let isLogin = await env.getIsLogin()
    if (!isLogin) return
    if (+this.lastNum <= 0) {
      // 产品需求，特定活动不提示下单抽奖
      let { activeId: active_id } = this.$route.query
      if (
        this.prizeInfo.chance_num_type === 'purchase' &&
        (active_id && active_id !== '152')
      ) {
        return this.$Toast(`您已没有抽奖机会了，下单后即可参与抽奖哦。`)
      } else if (
        ['ticket', 'integral', 'water'].includes(this.prizeInfo.chance_num_type)
      ) {
        if (+this.ticket < +this.prizeInfo.baseline_play_time) {
          return this.$Toast(
            `您的${this.getChangeName(this.prizeInfo)}数量不足`
          )
        }
        // 其余情况由后端报错返回
      } else if (this.prizeInfo.chance_num_type === 'share') {
        return (
          this.$Toast(`您没有抽奖次数了，分享给好友可获得更多机会哦`) &&
          this.goShare()
        )
      } else return this.$Toast(`您已经没有抽奖机会了`)
    }
    if (this.isOver) {
      return this.$Toast(`抽奖活动已经结束`)
    }
    if (this.isLotterying) return this.$Toast('您的奖品正在赶来，请耐心等待哦~')
    this.isLotterying = true
    let data: any = {}
    try {
      data = (await axios.get(`/api/mobile/activity/luckyDraw/lottery`, {
        params: {
          ...this.params,
          ...(await this.getPublicParams()),
        },
      })).data
    } catch (error) {
      this.isLotterying = false
      return
    }
    this.isLotterying = false
    let { rewards } = this.prizeInfo
    this.prizeIndex = rewards.findIndex(item => {
      return item.id === data.id
    })
    let record_id = 'record_id'
    let armId = 'armId'
    this.prizeInfo.rewards[this.prizeIndex][record_id] = data.record_id
    this.prizeInfo.rewards[this.prizeIndex][armId] = data.armId
    await this.$nextTick()
    // this.lastNum -= 1
    await this.countLastNum() // 查询剩余次数
    if (
      ['ticket', 'integral', 'water'].includes(this.prizeInfo.chance_num_type)
    ) {
      await this.getAccount()
    }
    const luckDarw = wheel as any
    await luckDarw.startDraw()
  }
  async gameOver() {
    if (this.isOver) {
      return this.$Toast(`活动已终止，敬请期待`)
    }
    this.currentPrize = this.prizeInfo.rewards[this.prizeIndex]
    console.log('currentPrize', this.currentPrize)
    this.records = [...this.records, this.prizeInfo.rewards[this.prizeIndex]] // 中奖纪录
    await this.getMyPrize()
    await showDiv(showPrizeMod, {
      backgroundColor: this.prizeInfo.primary_color,
      prize: this.currentPrize,
      prize2: this.myPrizes[0],
      exchange: this.exchange,
    })
    await this.countLastNum() // 查询剩余次数
    await this.couldShareTime()
  }
  exchange(data) {
    this.$set(this.myPrizes[0], 'is_receive', 1)
  }
  async getPublicParams() {
    let info = await env.getInfo()
    console.log('getInfo', info)
    return info ? info.publicParams : {}
  }

  // 验证url
  isURL(str_url) {
    let str = decodeURIComponent(str_url)
    let strRegex =
      "^(https|http)://([0-9a-z_!~*'()-]+)\\.([0-9a-z]+\\.)*[a-z]{2,6}"
    let re = new RegExp(strRegex)
    return re.test(str)
  }
}
